module.exports = __webpack_public_path__ + "static/media/savannah-regular.c3328765.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/savannah-regular.woff2
// module id = 2259
// module chunks = 47